export type AssistantIndexJobStatus =
    | "queued"
    | "running"
    | "succeeded"
    | "failed";

export type AssistantIndexJobView = {
    id: string;
    storyId: string;
    authorId: string;
    startSortOrder: number;
    endSortOrder: number;
    status: AssistantIndexJobStatus;
    totalChapters: number;
    embeddedChapters: number;
    failedChapters: number;
    error: string | null;
};

const UUID_RE =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const MAX_JOB_ERROR_LENGTH = 1_000;

export function isAssistantIndexJobView(
    value: unknown,
): value is AssistantIndexJobView {
    if (!value || typeof value !== "object") return false;
    const job = value as Record<string, unknown>;
    const hasValidCounts =
        Number.isSafeInteger(job.totalChapters) &&
        Number.isSafeInteger(job.embeddedChapters) &&
        Number.isSafeInteger(job.failedChapters) &&
        Number(job.totalChapters) >= 0 &&
        Number(job.embeddedChapters) >= 0 &&
        Number(job.failedChapters) >= 0 &&
        Number(job.embeddedChapters) + Number(job.failedChapters) <=
            Number(job.totalChapters);
    return (
        typeof job.id === "string" &&
        UUID_RE.test(job.id) &&
        typeof job.storyId === "string" &&
        UUID_RE.test(job.storyId) &&
        typeof job.authorId === "string" &&
        UUID_RE.test(job.authorId) &&
        Number.isSafeInteger(job.startSortOrder) &&
        Number.isSafeInteger(job.endSortOrder) &&
        Number(job.startSortOrder) > 0 &&
        Number(job.endSortOrder) >= Number(job.startSortOrder) &&
        Number(job.endSortOrder) - Number(job.startSortOrder) < 51 &&
        ["queued", "running", "succeeded", "failed"].includes(
            String(job.status),
        ) &&
        hasValidCounts &&
        (job.error === null ||
            (typeof job.error === "string" &&
                job.error.length <= MAX_JOB_ERROR_LENGTH))
    );
}
